import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import StudentList from '../views/StudentList.vue'
import LevelList from '../views/LevelList.vue'
import api from '@/api'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'students',
        name: 'StudentList',
        component: StudentList
      },
      {
        path: 'levels',
        name: 'LevelList',
        component: LevelList
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  const token = api.getToken()
  if (!token) {
    next('/login')
    return
  }
  next()
})

export default router
